/**
 * useHeader — fetches header settings + mega menu from CMS.
 */

import { useQuery } from '@tanstack/react-query';
import { fetchHeaderData } from '../api/header';
import type { HeaderData } from '../types/header';

export function useHeader() {
  return useQuery<HeaderData>({
    queryKey: ['header'],
    queryFn: fetchHeaderData,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
    refetchOnWindowFocus: false,
  });
}
